import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AirportAlert } from '../models/airport-alert.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../service/alert.service';



@Component({
  selector: 'app-edit-alert',
  templateUrl: './edit-alert.component.html',
  styleUrls: ['./edit-alert.component.scss']
})
export class EditAlertComponent implements OnInit {
  alert: AirportAlert;
  originalAlert: AirportAlert;
  isNew = false;
  isLoading = false;
  airportID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  selectedTitle: string;
  selectedDescription: string;
  selectedPriority: string;
  selectedEffectiveDate: Date;
  selectedExpirationDate: Date;
  selectedWebsite: string;
  selectedHidden: boolean;
  selectedPermanent: boolean;
  constructor(private _matDialogRef: MatDialogRef<EditAlertComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _alertService: AlertService) {
    this.alert = data.alert || new AirportAlert();
    this.isNew = data.isNew || false;
    if (this.isNew) {
      this.alert.code = '';
      this.alert.website = '';
      this.alert.priority = AirportAlert.parseAlertPriority('Low');
      this.alert.effectiveDate = new Date();
      this.alert.expirationDate = new Date();
      this.selectedPermanent = false;
      this.selectedHidden = false;
    }
    this.airportID = data.airID;
    this.originalAlert = Object.assign(new AirportAlert(), data.alert);
    this.itemsToChange = new Set<number> ();
    this.selectedTitle = this.alert.title || '';
    this.selectedDescription = this.alert.description || '';
    this.selectedPriority = AirportAlert.formatAlertPriority(this.alert.priority);
    this.selectedWebsite = this.alert.website;
    if (this.alert.effectiveDate === null) {
      this.selectedPermanent = false;
      this.selectedHidden = true;
      this.selectedEffectiveDate = new Date();
      this.selectedExpirationDate = this.alert.expirationDate;

    } else if (this.alert.expirationDate === null) {
      this.selectedPermanent = true;
      this.selectedHidden = false;
      this.selectedEffectiveDate = new Date();
    } else {
      this.selectedEffectiveDate = this.alert.effectiveDate;
      this.selectedExpirationDate = this.alert.expirationDate;
      this.selectedPermanent = false;
      this.selectedHidden = false;
    }
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      title: new FormControl(this.selectedTitle, [Validators.required]),
      description: new FormControl(this.selectedDescription, [Validators.required]),
      priority: new FormControl(this.selectedPriority, [Validators.required]),
      effectiveDate: new FormControl({effectiveDate: this.selectedEffectiveDate, disabled: this.selectedPermanent}),
      expirationDate: new FormControl({expirationDate: this.selectedExpirationDate, disabled: this.selectedPermanent}),
      website: new FormControl(this.selectedWebsite),
      hide: new FormControl(this.selectedHidden),
      permanent: new FormControl( this.selectedPermanent)
    });
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.alert.description = this.formGroup.get('description').value.replace(/[^\w\s~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, '');
      if (this.alert.description) {
        this.alert.description = this.alert.description.trim();
      }
      this.alert.priority = AirportAlert.parseAlertPriority(this.formGroup.get('priority').value.toLowerCase());
      this.alert.title = this.formGroup.get('title').value.replace(/[^\w\s~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, '');
      this.alert.website = this.formGroup.get('website').value;
      this.alert.effectiveDate = this.formGroup.get('effectiveDate').value;
      this.alert.expirationDate = this.formGroup.get('expirationDate').value;
      this.selectedHidden = this.formGroup.get('hide').value;
      this.selectedPermanent = this.formGroup.get('permanent').value;

      if (this.selectedPermanent) {
        this.alert.expirationDate = null;
        this.alert.priority = 1;
      }
      if (this.selectedHidden) {
        this.alert.effectiveDate = null;
      }
      if (this.isNew) {
        res = await this._alertService.postAirportAlert(this.airportID, this.alert);
        this.alert = AirportAlert.parse(res);
      } else {
        if (this.originalAlert.effectiveDate === this.alert.effectiveDate ||
          this.originalAlert.expirationDate === this.alert.expirationDate) {
          this.close({cancelBtnClicked: false, success: true, alert: this.alert});
        }
        res = await this._alertService.putAirportAlert(this.airportID, this.alert);
        Object.assign(this.alert, AirportAlert.parse(res));
        this.alert = AirportAlert.parse(res);
        console.log(this.alert.effectiveDate);
      }
      this.close({cancelBtnClicked: false, success: true, alert: this.alert});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.alert, this.originalAlert);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
  clickPermanent() {
    if (!this.selectedHidden) {
      this.selectedExpirationDate = null;
    }
  }
}
